var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"tunnel","width":"100%","height":"100%","preserveAspectRatio":"xMidYMid meet","viewBox":"-100 -100 200 200","visibility":"hidden"}})}
var staticRenderFns = []

export { render, staticRenderFns }